import React from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Admissions from "./pages/Admissions";
import Contact from "./pages/Contact";
import ScrollToTop from "./components/ScrollToTop";
import PrivateRoute from "./components/PrivateRoute";
import AdminPanel from "./pages/AdminPanel";
import Login from "./pages/Login";
import WhatsAppButton from "./components/WhatsAppButton";
import CareersPage from "./components/CareersPage";

import Admin from "./pages/Admin";

import ApplyForm from "./pages/ApplyForm";
import Ticker from "./components/Ticker"; // 👈 import

// ✅ Import Academics pages
import PrimarySchool from "./pages/PrimarySchool";
import MiddleSchool from "./pages/MiddleSchool";
import HighSchool from "./pages/HighSchool";

// ✅ Import Campuses pages
import BoysBranch from "./pages/BoysBranch";
import GirlsBranch from "./pages/GirlsBranch";
import RangilpurBranch from "./pages/RangilpurBranch";
import Gallery from "./pages/Gallery"; // adjust path if needed

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <Ticker />
      <Navbar />
      <main className="main-content">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/admissions" element={<Admissions />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/applyform" element={<ApplyForm />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          

          {/* ✅ Academics Dropdown Pages */}
          <Route path="/academics/primary" element={<PrimarySchool />} />
          <Route path="/academics/middle" element={<MiddleSchool />} />
          <Route path="/academics/high" element={<HighSchool />} />

          {/* ✅ Campuses Dropdown Pages */}
          <Route path="/campuses/boys" element={<BoysBranch />} />
          <Route path="/campuses/girls" element={<GirlsBranch />} />
          <Route path="/campuses/rangilpur" element={<RangilpurBranch />} />
<Route path="/gallery" element={<Gallery />} />

          {/* Admin Routes */}
          <Route path="/adminpanel" element={<AdminPanel />} />
          <Route
            path="/admin"
            element={
              <PrivateRoute>
                <Admin />
              </PrivateRoute>
            }
          />
        </Routes>
      </main>
      <Footer />
       <WhatsAppButton/>
    </div>
  );
}

export default App;
